import React from 'react';

export default function ProductModal({ product, onClose }) {
    if (!product) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>&times;</button>

                <div className="modal-body">
                    <div className="modal-image-container">
                        <img src={product.image} alt={product.name} className="modal-image" />
                    </div>

                    <div className="modal-details">
                        <span className="modal-type">{product.type}</span>
                        <h2 className="modal-title">{product.name}</h2>
                        <p className="modal-price">{product.price}</p>
                        <p className="modal-description">{product.description}</p>

                        <div className="modal-specs">
                            <h3>Specifications</h3>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Origin</td>
                                        <td>Italy</td>
                                    </tr>
                                    <tr>
                                        <td>Finish</td>
                                        <td>Polished</td>
                                    </tr>
                                    <tr>
                                        <td>Thickness</td>
                                        <td>18mm - 20mm</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <button className="inquiry-btn">Enquire Now</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
